module.exports = require('./src/wordCloud');


//////////////////
// WEBPACK FOOTER
// ./~/echarts-wordcloud/index.js
// module id = 845
// module chunks = 128